export default __webpack_public_path__ + "static/media/img5.8ddc3be8.jpg";